import {NgModule} from '@angular/core';
import {MapDialogComponent} from './map-dialog.component';
import {AppDialogModule} from '@components/dialog/modules/app-dialog.module';
import {ButtonModule} from '@components/button/modules/button.module';

@NgModule({
    declarations: [MapDialogComponent],
    imports: [
        AppDialogModule,
        ButtonModule
    ]
})
export class MapDialogModule {
}
